<template>
  <div class="personal_tax_other">
    <div class="column">
      <b-field
        :label="`${$t('dividends')}`"
        :message="$t(validation.firstError('dividendsValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="dividendsValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="`${$t('property_for_rent')}`"
        :message="$t(validation.firstError('propertyForRentValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="propertyForRentValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div class="column">
      <b-field :label="`${$t('property_for_transfer')}`"></b-field>
      <div class="columns is-multiline">
        <div class="column is-offset-1 is-11">
          <b-field
            :label="`${$t('property_transfer_revenue')}`"
            :message="$t(validation.firstError('propertyTransferRevenueValue'))"
          >
            <p class="control">
              <b-button>¥RMB</b-button>
            </p>
            <b-input
              v-model="propertyTransferRevenueValue"
              :placeholder="`${$t('please_input_int_amt')}`"
            />
          </b-field>
        </div>

        <div class="column is-offset-1 is-11">
          <b-field
            :label="`${$t('property_origin_amount')}`"
            :message="$t(validation.firstError('propertyOriginAmountValue'))"
          >
            <p class="control">
              <b-button>¥RMB</b-button>
            </p>
            <b-input
              v-model="propertyOriginAmountValue"
              :placeholder="`${$t('please_input_int_amt')}`"
            />
          </b-field>
        </div>

        <div class="column is-offset-1 is-11">
          <b-field
            :label="`${$t('reasonable_expense')}`"
            :message="$t(validation.firstError('reasonableExpenseValue'))"
          >
            <p class="control">
              <b-button>¥RMB</b-button>
            </p>
            <b-input
              v-model="reasonableExpenseValue"
              :placeholder="`${$t('please_input_int_amt')}`"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="column">
      <b-field
        :label="`${$t('incident_income')}`"
        :message="$t(validation.firstError('incidentIncomeValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="incidentIncomeValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div v-if="isShowResult" class="column">
      <div class="column has-text-centered result-title">
        <strong>{{ $t("expect_personal_tax") }}</strong>
      </div>
      <b-table
        :data="this.tableData"
        :columns="this.tableColumns"
        :hoverable="true"
        :bordered="true"
        :striped="true"
      >
      </b-table>
    </div>

    <div class="column">
      <b-button
        @click="calculate"
        class="is-primary"
        style="background-color: rgba(46,110,182,0.9)"
      >
        {{ $t("calculate") }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dividendsValue: 0,
      propertyForRentValue: 0,
      propertyTransferRevenueValue: 0,
      propertyOriginAmountValue: 0,
      reasonableExpenseValue: 0,
      incidentIncomeValue: 0,
      tableData: "",
      tableColumns: "",
      isShowResult: false,
    };
  },

  validators: {
    dividendsValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    propertyForRentValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    propertyTransferRevenueValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    propertyOriginAmountValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    reasonableExpenseValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    incidentIncomeValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
  },

  methods: {
    calculate() {
      this.tableData = [
        {
          dividends: this.$options.filters.formatNumber(this.calDividends()),
          property_for_rent: this.$options.filters.formatNumber(
            this.calPropertyForRent()
          ),
          property_for_transfer: this.$options.filters.formatNumber(
            this.calPropertyForTransfer()
          ),
          incident_income: this.$options.filters.formatNumber(
            this.calIncidentIncome()
          ),
          total: this.$options.filters.formatNumber(this.calTotal()),
        },
      ];

      this.columns();

      this.$validate().then((success) => {
        if (success) {
          this.isShowResult = true;
        }
      });
    },

    calDividends() {
      return this.dividendsValue * 0.2;
    },

    calPropertyForRent() {
      if (this.propertyForRentValue <= 4000) {
        if (this.propertyForRentValue < 0) {
          return 0;
        } else {
          return (this.propertyForRentValue - 800) * 0.2;
        }
      } else {
        return this.propertyForRentValue * 0.8 * 0.2;
      }
    },

    calPropertyForTransfer() {
      return (
        (this.propertyTransferRevenueValue -
          this.propertyOriginAmountValue -
          this.reasonableExpenseValue) *
        0.2
      );
    },

    calIncidentIncome() {
      return this.incidentIncomeValue * 0.2;
    },

    calTotal() {
      return (
        this.calDividends() +
        this.calPropertyForRent() +
        this.calPropertyForTransfer() +
        this.calIncidentIncome()
      );
    },

    columns() {
      this.tableColumns = [
        {
          field: "dividends",
          label: this.$t("dividends"),
          numeric: true,
        },
        {
          field: "property_for_rent",
          label: this.$t("property_for_rent"),
          numeric: true,
        },
        {
          field: "property_for_transfer",
          label: this.$t("property_for_transfer"),
          numeric: true,
        },
        {
          field: "incident_income",
          label: this.$t("incident_income"),
          numeric: true,
        },
        {
          field: "total",
          label: this.$t("total"),
          numeric: true,
        },
      ];
    },
  },
};
</script>

<style scoped>
.result-title {
  font-size: 1.2rem;
  padding-bottom: 0rem;
}
</style>
